import { BarChart3, Compass, Globe2, IdCard, Layers, Megaphone, Send, Wallet } from "lucide-react";
import { FeatureCard } from "./FeatureCard";
import { SectionHeading } from "./SectionHeading";
import { GlowOrb } from "./Glow";

const PitchVisual = () => (
  <div className="flex h-full flex-col justify-end gap-3" aria-hidden="true">
    {[["Submitted", "w-full", "bg-white/25"], ["Opened", "w-4/5", "bg-white/40"], ["In review", "w-3/5", "bg-pa-orange"], ["Decision", "w-2/5", "bg-white/10"]].map(([s, w, c]) => (
      <div key={s} className="flex items-center gap-4">
        <span className="w-24 shrink-0 font-mono text-[11px] uppercase tracking-wider text-pa-dim">{s}</span>
        <span className={`h-2 ${w} ${c} origin-left transition-transform duration-700 ease-out-expo group-hover:scale-x-105`} />
      </div>
    ))}
  </div>
);

const OppVisual = () => (
  <div className="flex flex-wrap gap-2" aria-hidden="true">
    {["Playlist", "Radio", "Press", "Sync", "Marketing", "Industry"].map((c, i) => (
      <span key={c} className={`border px-3 py-1.5 text-xs font-semibold uppercase tracking-wider ${i === 3 ? "border-pa-orange text-pa-orange-text" : "border-white/15 text-pa-muted"}`}>{c}</span>
    ))}
  </div>
);

const FEATURES = [
  { title: "Music Pitching", desc: "Submit music to relevant opportunities and track your pitch journey from submission to decision.", icon: Send, cls: "md:col-span-2 lg:row-span-2", visual: <PitchVisual /> },
  { title: "Opportunities", desc: "Discover playlist, radio, press, sync, marketing and industry opportunities.", icon: Compass, cls: "md:col-span-2", visual: <OppVisual /> },
  { title: "Release Management", desc: "Organize your releases, metadata and distribution workflow.", icon: Layers },
  { title: "Analytics", desc: "Understand your streams, audience, markets and growth.", icon: BarChart3 },
  { title: "Campaigns", desc: "Build and manage campaigns around your releases.", icon: Megaphone },
  { title: "Royalties & Revenue", desc: "Track your music revenue and financial performance.", icon: Wallet },
  { title: "Artist Profile & EPK", desc: "Create a professional artist profile you can share anywhere.", icon: IdCard },
  { title: "Market Intelligence", desc: "See where your audience is and where your music is growing.", icon: Globe2 },
];

export const Features = () => (
  <section id="features" data-testid="features-section" className="relative overflow-hidden border-t border-white/10 bg-pa-black">
    <GlowOrb className="-right-60 top-20 h-[620px] w-[620px]" strength="sm" />
    <GlowOrb className="-left-72 bottom-0 h-[560px] w-[560px]" strength="sm" />
    <div className="relative mx-auto max-w-[1400px] px-5 py-section-sm sm:px-8 lg:px-12 lg:py-section">
      <SectionHeading eyebrow="Features / 02" lines={["Everything you", "need to build."]} label="Everything you need to build.">
        Eight connected tools, one app. Built so the work after the upload finally lives in one place.
      </SectionHeading>
      <div className="mt-16 grid auto-rows-[minmax(250px,auto)] gap-3 md:grid-cols-2 lg:mt-24 lg:grid-cols-4">
        {FEATURES.map((f, i) => (
          <FeatureCard key={f.title} index={i + 1} title={f.title} desc={f.desc} icon={f.icon} className={f.cls || ""} delay={(i % 4) * 0.06}>
            {f.visual}
          </FeatureCard>
        ))}
      </div>
    </div>
  </section>
);
